function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 16.5,
  fill: "#5FA8E5",
  stroke: "#37648B"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 3,
  d: "M8.061 15.939l8 8M13.939 23.939l13-13"
});

var SvgIconCheckBlue = function SvgIconCheckBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 34 34",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgIconCheckBlue;